import {
  CheckedImportDataDetailResponse,
  CheckedImportDataResponse,
  CheckedRestaurantResponse,
} from 'features/Store/models';
import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';

const dataValidationService = {
  getErrorImportDataDetail(
    restaurantId?: number,
    counterPatternId?: number
  ): Promise<CommonResponse<CheckedImportDataDetailResponse>> {
    let url = `/get-error-import-data-detail`;

    const params = new URLSearchParams();

    // Add parameters
    if (restaurantId) {
      params.append('restaurant_id', restaurantId.toString());
    }
    if (counterPatternId) {
      params.append('counter_pattern_id', counterPatternId.toString());
    }
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return axiosClient.get(url);
  },
  getErrorImportDataSummaryByRestaurants(
    restaurantIds: number[]
  ): Promise<CommonResponse<CheckedRestaurantResponse[]>> {
    let url = `/get-error-import-data-summary-by-restaurants`;

    const params = new URLSearchParams();
    // Add parameters
    params.append('restaurant_ids', restaurantIds.join(','));
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return axiosClient.get(url);
  },
  getErrorImportDataSummaryByPattern(counterPatternId: number): Promise<CommonResponse<CheckedImportDataResponse>> {
    let url = `/get-error-import-data-summary-by-counter-pattern`;

    const params = new URLSearchParams();
    // Add parameters
    params.append('counter_pattern_id', counterPatternId.toString());
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return axiosClient.get(url);
  },
};

export default dataValidationService;
